import { Header } from "@client/components/layout/Header";
import { MobileNav } from "@client/components/layout/MobileNav";
import { Sidebar } from "@client/components/layout/Sidebar";
import { useGlobalShortcuts } from "@client/lib/keyboard";
import type { ReactNode } from "react";
import { useRef, useState } from "react";

type AppShellProps = {
  readonly children: ReactNode;
};

export function AppShell({ children }: AppShellProps) {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [newBasketOpen, setNewBasketOpen] = useState(false);

  useGlobalShortcuts({
    onNewBasket: () => setNewBasketOpen(true),
    onFocusSearch: () => searchInputRef.current?.focus(),
  });

  return (
    <div className="flex min-h-screen bg-app text-fg-1">
      <Sidebar />
      <main className="flex min-w-0 flex-1 flex-col pb-16 md:pb-0">
        <Header
          searchInputRef={searchInputRef}
          newBasketOpen={newBasketOpen}
          onNewBasketOpenChange={setNewBasketOpen}
        />
        {children}
      </main>
      <MobileNav />
    </div>
  );
}
